import { render, staticRenderFns } from "./CompanyPageHeading.vue?vue&type=template&id=2a0b3e67&scoped=true"
import script from "./CompanyPageHeading.vue?vue&type=script&lang=js"
export * from "./CompanyPageHeading.vue?vue&type=script&lang=js"
import style0 from "./CompanyPageHeading.vue?vue&type=style&index=0&id=2a0b3e67&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a0b3e67",
  null
  
)

export default component.exports